import { HasAccessTo, IsOwnerAdmin, IsSuperAdmin } from 'app/components';
import { OWNER, SUPERADMIN } from 'app/common/Authorization/entities';
import { EDIT } from 'app/common/Authorization/permissions';
import type { User } from 'app/types';

type UseUserDetailsPanelPermissionsParams = {
  user: User | undefined;
  isLoggedInUser: boolean;
};

export const useUserDetailsPanelPermissions = ({ user, isLoggedInUser }: UseUserDetailsPanelPermissionsParams) => {
  const isSuperAdmin = IsSuperAdmin();
  const isOwnerAdmin = IsOwnerAdmin();
  const hasPermissionToEdit = HasAccessTo(OWNER, EDIT);

  // Super admins and owner admins are the only ones allowed to manage other users' owner/role.
  const isAdmin = isSuperAdmin || isOwnerAdmin;
  const canEditAdminFields = isAdmin && !isLoggedInUser;

  const roleName = user?.roleName.toUpperCase();
  const isProtectedRole = roleName === OWNER || roleName === SUPERADMIN;

  return {
    canManageOwners: isAdmin,
    canEditOwner: canEditAdminFields,
    canEditRole: canEditAdminFields,
    // Owner/Super Admin roles can only be reassigned by a super admin.
    canShowRoleAsDropdown: !isProtectedRole || isSuperAdmin,
    // Same rule as the block/unblock actions on the users overview.
    canBlockUser: hasPermissionToEdit && !isLoggedInUser,
  };
};
